/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useEffect, useRef, useState } from "react";
import { motion, useScroll, useTransform } from "motion/react";
import { RichText } from "@simplicitycms/simplicity-richtext";
import { useAuth } from "../../auth/hooks/useAuth";
import { isValidGuid } from "../../utils/empty-exists";
import { SimpliCitySDK } from "../../sdk";
import { Logger } from "../../utils/logger";

/*
 * Read the blog post here:
 * https://letsbuildui.dev/series/scroll-animations-with-framer-motion/scroll-linked-content-reveal-animation
 */
export const ScrollAnimation = (props) => {
    const _image = props?.image;
    // const settings = props?.settings;
    // const orientation = props?.orientation;
    const richtext = props?.richtext;

    const { token } = useAuth();

    const [image, setImage] = useState();
    const alt = image?.alt;
    const url = image?.url;

    const containerRef = useRef(null);

    useEffect(() => {
        const fetchImage = async (token, guid) => {
            if (isValidGuid(guid)) {
                let current_image = await SimpliCitySDK.images.findOne(token, guid);
                if (current_image && current_image.guid) {
                    setImage(current_image);
                }
            } else {
                setImage(undefined);
            }
        };
        Logger.debug(`Scroll Reveal Image... ${_image}`);
        fetchImage(token, _image);
    }, [token, _image]);

    const { scrollYProgress } = useScroll({
        target: containerRef,
        offset: ["start end", "end end"]
    });

    const bottomShadowValue = useTransform(
        scrollYProgress,
        [0, 1],
        ["-100%", "0%"]
    );
    const imageValue = useTransform(scrollYProgress, [0, 1], ["-100%", "0%"]);
    const topShadowValue = useTransform(
        scrollYProgress,
        [0, 1],
        ["-25%", "100%"]
    );

    return (
        <section className="scroll-container" ref={containerRef}>
            <div className="copy">
                <RichText richtext={richtext} />
            </div>
            <div className="img-container">
                <motion.div className="img-inner" style={{ translateX: imageValue }}>
                    <motion.div
                        className="bottom-shadow"
                        style={{ translateX: bottomShadowValue }}
                    />

                    <img
                        className="scroll-reveal-image-image"
                        src={url}
                        alt={alt}
                    />

                    <motion.div
                        className="top-shadow"
                        style={{ translateX: topShadowValue }}
                    />
                </motion.div>
            </div>
        </section>
    );
};
